// ============================================================
// SpeedmasterCore.FacetSearch
//
// "Search within results" — handles form submit, clear button,
// keyword pill dismiss, and input UX for the keyword search
// in the facets sidebar.
//
// Template: facets_facet_browse.tpl (form + pill markup)
// CSS: _facets-facet-browse.scss (.sm-facet-search-* classes)
// ============================================================

define('SpeedmasterCore.FacetSearch', [
	'underscore'
], function (_) {
	'use strict';

	// --- Build new URL with updated keywords ---

	function buildUrl(keywords) {
		var pathname = window.location.pathname;
		var search = window.location.search.substring(1);
		var params = search ? search.split('&') : [];

		// Remove existing keywords param
		params = _.filter(params, function (p) {
			return p.indexOf('keywords=') !== 0;
		});

		// Add new keywords if not empty
		if (keywords) {
			params.push('keywords=' + encodeURIComponent(keywords));
		}

		return pathname + (params.length ? '?' + params.join('&') : '');
	}

	// --- Form submit ---

	document.addEventListener('submit', function (e) {
		var form = e.target;
		if (!form.classList.contains('sm-facet-search')) { return; }

		e.preventDefault();

		var input = form.querySelector('.sm-facet-search__input');
		var keywords = input ? input.value.trim() : '';
		window.location.href = buildUrl(keywords);
	});

	// --- Clear keywords (pill × or input × button) ---

	document.addEventListener('click', function (e) {
		var trigger = e.target.closest('[data-action="sm-clear-keywords"]');
		if (!trigger) { return; }

		e.preventDefault();
		window.location.href = buildUrl('');
	});

	// --- Auto-select input text on focus (quick re-search) ---

	document.addEventListener('focusin', function (e) {
		if (e.target.classList && e.target.classList.contains('sm-facet-search__input')) {
			e.target.select();
		}
	});
});
